module.exports = __webpack_public_path__ + "static/media/logo_via_plus.5425ac48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo_via_plus.png
// module id = 137
// module chunks = 0